import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type UpdateShipmentTractorNumberParams } from '../../infra/ShipmentRepository'
import { updateShipmentTractorNumber } from '../../use-cases/updateShipmentTractorNumber'

export function useUpdateShipmentTractorNumber() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const updateTractor = useCallback(
    async ({ shipmentUUID, tractorNumber }: UpdateShipmentTractorNumberParams) => {
      setRequestStatus(RequestStatus.Pending)
      try {
        await updateShipmentTractorNumber({ shipmentUUID, tractorNumber })
        setRequestStatus(RequestStatus.Done)
      } catch (error) {
        sentry.log(error)
        setRequestStatus(RequestStatus.Error)
      }
    },
    []
  )

  return { updateTractor, requestStatus }
}
